export const Deso = `<svg viewBox="0 0 133 154" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.9823 0.5354V38.8854L101.92 94.9591L0.9823 153.959H84.1488C110.722 153.959 132.246 135.079 132.246 111.786V77.2591L0.9823 0.5354Z" fill="url(#paint0_linear)"/>
<path d="M0.9823 0.5354L132.246 77.259V42.7086C132.246 19.4154 110.699 0.5354 84.1488 0.5354H0.9823Z" fill="url(#paint1_linear)"/>
<path d="M70.0356 77.2598L0.981934 115.61V153.96L101.919 94.9598L70.0356 77.2598Z" fill="url(#paint2_linear)"/>
<defs>
<linearGradient id="paint0_linear" x1="33.2502" y1="35.039" x2="78.9066" y2="145.303" gradientUnits="userSpaceOnUse">
<stop stop-color="#0057FF"/>
<stop offset="1" stop-color="#00A3FF"/>
</linearGradient>
<linearGradient id="paint1_linear" x1="54.6681" y1="35.8187" x2="139.602" y2="13.3833" gradientUnits="userSpaceOnUse">
<stop stop-color="#0283FF"/>
<stop offset="1" stop-color="#01C2FF"/>
</linearGradient>
<linearGradient id="paint2_linear" x1="25.4773" y1="139.75" x2="144.429" y2="-18.0902" gradientUnits="userSpaceOnUse">
<stop stop-color="#0157FF"/>
<stop offset="1" stop-color="#00FFFF"/>
</linearGradient>
</defs>
</svg>`
